module.exports = __webpack_public_path__ + "img/music-note.637600d2.svg";